import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/payments.svg',
})
export class PaymentsComponent {}
